import { render, staticRenderFns } from "./WeeklyReportViewDetails.vue?vue&type=template&id=5247e402&scoped=true"
import script from "./WeeklyReportViewDetails.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewDetails.vue?vue&type=script&lang=js"
import style0 from "./WeeklyReportViewDetails.vue?vue&type=style&index=0&id=5247e402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247e402",
  null
  
)

export default component.exports